import React, { useContext, useEffect, useState } from 'react'
import { Sidebar, Topbar } from '../Library'
import { RoleContext } from '../Role/RoleContext'
import { RepairProvider } from '../Repair/RepairContext'
import { TopbarContext } from '../Library/TopbarContext'
import { AuthContext } from '../Auth/AuthContext'
import { useLocation, Route, Switch, Redirect } from 'react-router-dom'

import Home from '../Home/Home'
import Language from '../Language/Language'
import User from '../User/User'
import CreateUser from '../User/CreateUser'
import EditUser from '../User/EditUser'
import ImportExport from '../User/ImportExport'

import Repair from '../Repair/Repair'
import RepairDetail from '../Repair/RepairDetail'
import ServiceNavigation from '../ServiceInform/ServiceNavigation'

import Company from '../Company/Company'
import AddCompany from '../Company/AddCompany'
import CompanyDetail from '../Company/CompanyDetail'
import Floor from '../Floor/Floor'

import Booking from '../Booking/Booking'

import News from '../News/News'
import CreateNews from '../News/CreateNews'
import UpdateNews from '../News/UpdateNews'
import ViewNews from '../News/ViewNews'

import Gallery from '../Gallery/Gallery'
import CreateGallery from '../Gallery/CreateAlbum'
import Album from '../Gallery/Album'

import AboutUs from '../AboutUs/AboutUs'
import ContactCenter from '../ContactCenter/ContactCenter'
import TermsandPolicies from '../TermsandPolicies/TermsandPolicies'
import ViewTerm from '../TermsandPolicies/ViewTerm'

import FAQ from '../FAQ/FAQ'
import FAQcreate from '../FAQ/FAQcreate'
import FAQedit from '../FAQ/FAQEdit'

import Calendar from '../Calendar/Calendar'
import AddCalendar from '../Calendar/AddCalendar'
import UpdateCalendar from '../Calendar/UpdateCalendar'

import Inbox from '../Inbox/Inbox'

import Role from '../Role/Role'
import CreateRole from '../Role/CreateRole'
import UpdateRole from '../Role/UpdateRole'
import ActivityLogNavigation from '../ActivityLog/ActivityNavigation';
import AdministrationNavigation from '../Administration/AdministrationNavigation';
import useWindowDimensions from '../ScreenSize'
import NotFound from '../DefaultPage/NotFound';
import ChangePassword from '../Auth/ChangePassword'
import CreateBookingLocation from '../Booking/CreateBookingLocation'
import BookingDetail from '../Booking/BookingDetail'
import EditBookingLocation from '../Booking/EditBookingLocation'
import CheckInQRCode from '../Booking/CheckInQRCode'
import Delivery from '../Delivery/Delivery'
import Visitor from '../Visitor/Visitor'
import Linkroom from '../Linkroom/Linkroom'
import ListSpare from '../ListSpare/ListSpare'
import MonitorScreen from '../Monitor/MonitorScreen'
import EditVisitor from '../Visitor/VisitorEditSecurity'
import FrontScreen from '../FrontScreen/FrontScreen'

import CreateDelivery from '../Delivery/CreateDelivery'
import DeliveryDetail from '../Delivery/DeliveryDetail'
import EditDelivery from '../Delivery/EditDelivery'

import Rental from '../Rental/Rental'
import RentalDetail from '../Rental/RentalDetail'
import AddRental from '../Rental/AddRental'

export default function MainStack(){
  const { width } = useWindowDimensions()
  const topbarCx = useContext(TopbarContext)
  const authCx = useContext(AuthContext)
  const roleCx = useContext(RoleContext)
  const location = useLocation()

  //console.log(roleCx)

  const mainScreens = [
    { path: '/', component: <Home/>, exact: true, isShow: true },
    { path: '/change-password', component: <ChangePassword/>, exact: false, isShow: true },
    { path: '/language', component: <Language/>, exact: false, isShow: true },
    { path: '/view-term', component: <ViewTerm/>, exact: false, isShow: true },
    { path: '/administration', component: <AdministrationNavigation/>, exact: false, isShow: localStorage.getItem("is_super_admin") === "true" ? true:false },
    // User
    { path: '/user', component: <User/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.user_list") },
    { path: '/user/create', component: <CreateUser/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.user_add") },
    { path: '/user/edit/:userid', component: <EditUser/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.user_list") },
    { path: '/user/import-export', component: <ImportExport/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.user_import") },
    // Repair
    { path: '/repair', component: <Repair/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.my_task_list") },
    { path: '/repair/:id', component: <RepairDetail/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.my_task_list") },
    { path: '/service', component: <ServiceNavigation/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.service_inform") },
    { path: '/listspare', component: <ListSpare/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.my_task_list") },
    { path: '/monitor', component: <MonitorScreen/>, exact: false, isShow: true },
    // Role
    { path: '/role', component: <Role/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.role") },
    { path: '/role/edit/:id' , component: <UpdateRole/> , exact: false, isShow: roleCx.checkPermission("_MENU_", "app.role") },
    { path: '/role/add', component: <CreateRole/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.role") },
    //Floor
    { path: '/floor', component: <Floor/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.company_list") },
    //Company
    { path: '/company', component: <Company/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.company_list") },
    { path: '/company/detail/:id', component: <CompanyDetail/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.company_list") },
    { path: '/company/add', component: <AddCompany/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.company_add") },
    { path: '/rental', component: <Rental/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.admin_rental")},
    { path: '/rental/add', component: <AddRental/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.admin_rental") },
    { path: '/rental/detail/:id', component: <RentalDetail/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.admin_rental") },
    //Booking
    { path: '/booking', component: <Booking/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "page.admin_booking") },
    { path: '/booking/create', component: <CreateBookingLocation/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "page.admin_booking") },
    { path: '/booking/view/:location_id', component: <BookingDetail/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "page.admin_booking")},
    { path: '/booking/view/:location_id/qr_code', component: <CheckInQRCode/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "page.admin_booking") },
    { path: '/booking/edit/:locationId', component: <EditBookingLocation/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "page.admin_booking") },
    //News
    { path: '/news', component: <News/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.news_list") },
    { path: '/news/view/:news_id', component: <ViewNews/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.news_list") },
    { path: '/news/edit/:news_id', component: <UpdateNews/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.news_list") },
    { path: '/news/create', component: <CreateNews/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.news_add") },
    //Gallery
    { path: '/gallery', component: <Gallery/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.album") },
    { path: '/gallery/create', component: <CreateGallery/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.album") },
    { path: '/gallery/edit/:id', component: <Album/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.album") },
    //Inbox
    { path: '/inbox', component: <Inbox/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.inbox_send") },
    //Calendar
    { path: '/calendar', component: <Calendar/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.calendar") },
    { path: '/calendar/add', component: <AddCalendar/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.calendar_add") },
    { path: '/calendar/edit/:id', component: <UpdateCalendar/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.calendar") },
    //Content
    { path: '/term', component: <TermsandPolicies/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.terms") },
    { path: '/contact', component: <ContactCenter/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.contact") },
    { path: '/aboutus', component: <AboutUs/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.about_us") },
    //Faq
    { path: '/faq', component: <FAQ/> , exact: true, isShow: roleCx.checkPermission("_MENU_", "app.faq_list") },
    { path: '/faq/create', component: <FAQcreate/> , exact: true, isShow: roleCx.checkPermission("_MENU_", "app.faq_list") },
    { path: '/faq/edit/:id', component: <FAQedit/> , exact: true, isShow: roleCx.checkPermission("_MENU_", "app.faq_list") },
    //Log
    { path: '/log', component: <ActivityLogNavigation/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.activity_log") },
    //Delivery
    { path: '/delivery', component: <Delivery/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.admin_linkservice_delivery") },
    { path: '/delivery/create', component: <CreateDelivery/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.admin_linkservice_delivery") },
    { path: '/delivery/view/:deliveryId', component: <DeliveryDetail/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.admin_linkservice_delivery") },
    { path: '/delivery/edit/:deliveryId', component: <EditDelivery/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.admin_linkservice_delivery") },
    //Visitor
    {
      path: '/visitor', component: <Visitor/>, exact: false, isShow: roleCx.userRole != 'User'? roleCx.checkPermission("_MENU_", "app.admin_visitor"):false
    },
    //Linkroom
    {
      path: '/linkroom', component: <Linkroom/>, exact: false, isShow: roleCx.checkPermission("_MENU_", "app.linkroom")
    },
    // Screen
    { path: '/front-screen', component: <FrontScreen/>, exact: true, isShow: roleCx.checkPermission("_MENU_", "app.front_screen") },
  ]

  const mainScreenRender = mainScreens.map((item, key) => {
    if(item.isShow){
      return (
        <Route path={item.path} exact={item.exact} key={key}>
          {item.component}
        </Route>
      )
    }else{
      return null
    }
  })
  return(
    <RepairProvider>
      { authCx.isAuth ?
        <>
        
        { width < 768 ?
        <div 
        className="d-flex d-md-none mobile-sidebar">
          <Sidebar 
          style={{
            //width: topbarCx.isSidebarOpen ? 250 : 0,
            left: topbarCx.isSidebarOpen ? 0 : -250
          }}
          onToggleClose={()=>topbarCx.setSidebar(false)}
          onClickOutside={()=>topbarCx.setSidebar(false)}
          />
        </div>
        : 
        <div className="d-none d-md-flex">
          <Sidebar onClickOutside={()=>{topbarCx.setSidebar(false)}}/>
        </div>
        }
        <div>
          <Topbar onClickOpen={()=>topbarCx.setSidebar(true)}/>
          <div className="app-container">
            <div className="content">
              <Switch>
                { mainScreenRender }
                {/*Redirect to home when logged in*/}
                <Route path="/login">
                  <Redirect to="/"/>
                </Route>
                <Route path="/forgot">
                  <Redirect to="/"/>
                </Route>
                <Route>
                  <NotFound/>
                </Route>
              </Switch>
            </div>
          </div>
        </div>
        </> :
        <>
        { location.pathname !== "/login" 
        && location.pathname !== "/forgot"
        && !location.pathname.startsWith("/resetpassword") ?
        <Redirect to="/login"/>
        : null
        }
        </>
      }
    </RepairProvider>
  )
}
